export default __webpack_public_path__ + "static/media/review-11.8842cbe2.png";